import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Box } from 'rebass';
import { Controller, Scene } from 'react-scrollmagic';

import TeamMemberCard from './components/TeamMemberCard';
import Typography, {
  TypographyContextProvider,
} from '../../components/Typography/Typography';

import colourMatching from '../../utils/colourMatching';
import isFadeEnabled from '../../utils/isFadeEnabled';
import { TeamMemberSectionStoryblok } from '../../types/storyblok';
import classNames from 'classnames';
import { Type } from '../../base/Type/Type';

export const Container = ({
  title,
  items,
  colourScheme,
}: TeamMemberSectionStoryblok) => (
  <TypographyContextProvider value={{ colourScheme }}>
    <Box
      as="section"
      className="repeating-border-section"
      backgroundColor={colourMatching(colourScheme)}
      px={[3, 4]}
      pt={[8, 9, 10]}
    >
      <Controller globalSceneOptions={{ triggerHook: 'onEnter' }}>
        <Scene classToggle="full-opacity">
          <Box
            as="div"
            className={classNames(
              'max-w-standard',
              isFadeEnabled() && 'zero-opacity !mx-auto'
            )}
          >
            {title && (
              <Box width={1} textAlign="center" pb={[3, 4, 8]}>
                <Type as="h2" className="mb-1 mx-auto">
                  {title}
                </Type>
              </Box>
            )}
            <Box as="div" className="w-full">
              <Box
                as="div"
                className="bottom-border grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 max-w-standard mx-auto gap-y-5"
              >
                {items.length > 0 ? (
                  items.map((item: any) => (
                    <Box
                      key={item.uuid}
                      px={3}
                      pb={[4, , 8]}
                      className="mx-auto"
                    >
                      <TeamMemberCard {...item} />
                    </Box>
                  ))
                ) : (
                  <Typography textAlign="center" width={1}>
                    No cards added
                  </Typography>
                )}
              </Box>
            </Box>
          </Box>
        </Scene>
      </Controller>
    </Box>
  </TypographyContextProvider>
);

const TeamSection = (props: any) => {
  const data = useStaticQuery(graphql`
    {
      records: allAirtable(
        filter: { table: { eq: "FF Employees" } }
        sort: { data: { Full_Name: ASC } }
      ) {
        nodes {
          id
          data {
            name: Full_Name
            description: Title
            teams: Teams
            location: Primary_Location
            link: LinkedIn
            photo: Photo {
              images: localFiles {
                childImageSharp {
                  gatsbyImageData(width: 300, height: 420)
                }
              }
            }
          }
        }
      }
    }
  `);

  const nodes = data.records.nodes
    .map((item: any) => ({ uuid: item.id, ...item.data }))
    .filter((item: any) =>
      props.location ? props.location == item.location : true
    )
    .filter((item: any) =>
      props.team ? !!item.teams && item.teams.includes(props.team) : true
    );
  return <Container items={nodes} {...props} />;
};

export default TeamSection;
